export default __webpack_public_path__ + "static/media/search.7cb48616.svg";